class TimeZoneManager {
  init() {
    const tz = encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone)

    document.cookie = `timezone=${tz}; expires=Wed, 15 Jan 2030 12:00:00 UTC; path=/`
  }
}

export default TimeZoneManager
